import PlayerList from './PlayerList'
import PlayerShow from './PlayerShow'

const playersEntrypoints = {
  list: PlayerList,
  show: PlayerShow,
}

export default playersEntrypoints
